import { TYPE_FILTERS } from '@components/RepositoryApp/constants';

export const getTabLabels = (style?: Study['style']) => {
  // Global repo
  if (!style)
    return {
      insights: 'Insights',
      reels: 'Reels',
      highlights: 'Highlights',
      interviews: 'Interviews',
      survey_results: 'Survey results',
      all: 'All'
    } as Record<string, string>;

  // Study-specific repo
  const studySpecificLabels = (() => {
    switch (style) {
      case 'video_call':
        return {
          reels: 'Reels',
          highlights: 'Highlights',
          interviews: 'Interviews'
        };
      case 'unmoderated_test':
        return {
          reels: 'Reels',
          highlights: 'Highlights',
          interviews: 'Recordings'
        };
      case 'survey':
      case 'panel':
        return {
          survey_results: 'Survey results'
        };
      default:
        return {};
    }
  })();

  return {
    insights: 'Insights',
    ...(studySpecificLabels as Record<string, string>),
    all: 'All'
  };
};

export const extraFilter = ({
  study,
  teamId,
  storedTab,
  currentTab
}: {
  study?: Study;
  teamId?: number | null;
  storedTab?: string;
  currentTab: string;
}) => {
  if (study) {
    if (storedTab === 'all') {
      return `study_ids:${study.id}`;
    }
    return `${TYPE_FILTERS[currentTab]} AND study_ids:${study.id}`;
  } else if (teamId) {
    if (storedTab === 'all') {
      return `team_ids:${teamId}`;
    }
    return `${TYPE_FILTERS[currentTab]} AND team_ids:${teamId}`;
  }

  return TYPE_FILTERS[currentTab];
};
